import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    negativeSearchTerm: "best betting",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    positiveSearchTerm: "best betting sites",
    estimatedMatchRelevance: "92%",
  },
  {
    id: 2,
    negativeSearchTerm: "betting sites uk",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    positiveSearchTerm: "betting uk",
    estimatedMatchRelevance: "88%",
  },
  {
    id: 3,
    negativeSearchTerm: "sports betting",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    positiveSearchTerm: "sport betting",
    estimatedMatchRelevance: "92%",
  },
  {
    id: 4,
    negativeSearchTerm: "best betting sites",
    matchType: "Exact",
    negativeLevel: "Adgroup",
    positiveSearchTerm: "betting sites best",
    estimatedMatchRelevance: "88%",
  },
  {
    id: 5,
    negativeSearchTerm: "UK sports betting",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    positiveSearchTerm: "UK betting",
    estimatedMatchRelevance: "92%",
  },
  {
    id: 6,
    negativeSearchTerm: "online betting sites",
    matchType: "Broad",
    negativeLevel: "Adgroup",
    positiveSearchTerm: "online betting sites",
    estimatedMatchRelevance: "92%",
  },
];
// Example options for the autocomplete
const definitionOptions = [
  { label: "High Intent", value: "high_intent" },
  { label: "Returning Visitors", value: "returning_visitors" },
  { label: "Promo Seekers", value: "promo_seekers" },
  { label: "All Visitors", value: "all_visitors" },
];

const AiRecomondationST = ({ open, rowData, onClose }: any) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    {
      field: "negativeSearchTerm",
      headerName: "Negative Search Term",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "matchType",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "negativeLevel",
      headerName: "Negative Level",
      flex: 0.8,
      minWidth: 140,
    },
    {
      field: "positiveSearchTerm",
      headerName: "Positive Search Term",
      flex: 1,
      minWidth: 180,
    },
    {
      field: "estimatedMatchRelevance",
      headerName: "Estimated Match Relevance",
      flex: 0.8,
      minWidth: 180,
    },
    {
      field: "Definition",
      headerName: "Definition",
      flex: 0.8,
      minWidth: 160,
      sortable: false,
      renderCell: () => (
        <Autocomplete
          size="small"
          options={definitionOptions}
          getOptionLabel={(option) => option.label}
          sx={{ width: "100%" }}
          renderInput={(paramsInput) => (
            <TextField
              {...paramsInput}
              placeholder="Select..."
              variant="standard"
              color="secondary"
              InputProps={{
                ...paramsInput.InputProps,
                disableUnderline: true, // 🔑 hides underline
              }}
            />
          )}
        />
      ),
    },
  ];

  if (!rowData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>top betting - AI Recommendations</DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", display: "grid" }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            //   disableMultipleRowSelection
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
            initialState={{
              pinnedColumns: {
                left: ["searchTerm", "matchType", "keywordname"],
                right: ["Definition"],
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 20px 16px" }}>
        <Button color="secondary" variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AiRecomondationST;
